import * as React from 'react';
import {StickerFormatEnum} from '../../../domain/enums/StickerFormatEnum';

// Line icons for the four ways to create a moment. Drawn inline with
// currentColor, so the parent's `color` (a theme token) decides the colour.
const PATHS: { [format: string]: React.ReactNode } = {
    [StickerFormatEnum.Video]: (
        <>
            <rect x="5" y="13" width="26" height="22" rx="5"/>
            <path d="M31 21.5 41.2 15.6a1.2 1.2 0 0 1 1.8 1v14.8a1.2 1.2 0 0 1-1.8 1L31 26.5"/>
            <circle cx="12" cy="20" r="1.6" fill="currentColor" stroke="none"/>
        </>
    ),
    [StickerFormatEnum.Audio]: (
        <>
            <rect x="17" y="5" width="14" height="24" rx="7"/>
            <path d="M17 13.5h5M17 18.5h5M26 13.5h5M26 18.5h5"/>
            <path d="M10 22.5a14 14 0 0 0 28 0"/>
            <path d="M24 36.5V43M18 43h12"/>
        </>
    ),
    [StickerFormatEnum.Image]: (
        <>
            <path d="M5 17.5a4.5 4.5 0 0 1 4.5-4.5h5.2l2.6-4h13.4l2.6 4h5.2a4.5 4.5 0 0 1 4.5 4.5V36a4.5 4.5 0 0 1-4.5 4.5h-29A4.5 4.5 0 0 1 5 36z"/>
            <circle cx="24" cy="26" r="7.5"/>
            <circle cx="24" cy="26" r="3"/>
            <path d="M36.5 19h1.5"/>
        </>
    ),
    [StickerFormatEnum.Upload]: (
        <>
            <path d="M6 30v6.5A4.5 4.5 0 0 0 10.5 41h27a4.5 4.5 0 0 0 4.5-4.5V30"/>
            <path d="M24 31V7M15.5 15.5 24 7l8.5 8.5"/>
        </>
    ),
};

export default function FormatIcon({format, size = 44, className}: { format: string, size?: number, className?: string }) {
    return (
        <svg className={className} width={size} height={size} viewBox="0 0 48 48" fill="none"
             stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round"
             aria-hidden="true">
            {PATHS[format]}
        </svg>
    );
}
